<template>
    <b-modal
        id="group-export-download-modal"
        :title="$t('group.internship.download_list')"
        ok-only
        @ok="onOk"
        :ok-title="$t('common.download')"
        size="sm"
        modal-class="apprentice-default-modal">
        <b-form-group :label="$t('group.internship.list_by_paper_or_by_student')">
            <b-form-radio
                v-model="selected"
                :value="1"
                >{{ $t('group.internship.by_paper') }}
            </b-form-radio>
            <b-form-radio
                v-model="selected"
                :value="2"
                >{{ $t('group.internship.by_student') }}
            </b-form-radio>
        </b-form-group>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-group-show-export-download-modal-component',
    props: ['groupId'],
    data() {
        return {
            selected: 1,
        };
    },
    methods: {
        onOk() {
            window.location.href = this.routes.downloadProjectsByGroupId(this.groupId, this.selected === 2);
        },
    },
};
</script>

<style scoped></style>
